'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Emoji = require('@/components/inputtools/Emoji.vue');

var _Emoji2 = _interopRequireDefault(_Emoji);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_Emoji2.default],
    methods: {
        emitClose: function emitClose() {
            this.$emit('close');
        },
        onImgClick: function onImgClick(emoji) {
            var url = this.location + emoji.eCode + '.png';
            var code = emoji.text + ' ';

            this.ircinput.addImg(code, url);

            this.emitClose();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/inputtools/Emoji.vue
// module id = yJl2
// module chunks = 1